
export var fnCVR = function () {


    $('.cvr-address-import').off('click').on('click', function () {
        var index = $(this).attr('data-cvr');

        var address = $('#cvr_address_'+index).text();
        $('#address').val(address);

        var zip = $('#cvr_zip_'+index).text();
        $('#postal_code').val(zip);

        var city = $('#cvr_city_'+index).text();
        $('#city').val(city);

        $('#address').click();

    });


};